import React from 'react';

const Footer = () => {
    return (
        <footer style={{
            backgroundColor: '#000',
            color: 'var(--text-muted)',
            padding: '4rem 2rem 2rem',
            borderTop: '1px solid var(--border-subtle)'
        }}>
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                marginBottom: '4rem'
            }}>
                <div style={{ marginBottom: '2rem' }}>
                    <h2 style={{
                        color: 'var(--text-main)',
                        marginBottom: '1rem',
                        fontSize: '1.5rem',
                        letterSpacing: '-0.02em',
                        fontFamily: 'Manrope, sans-serif'
                    }}>Seikaia</h2>
                    <p style={{ maxWidth: '300px', fontSize: '0.9rem' }}>
                        Bridging the gap between botany and technology.
                    </p>
                </div>

                <div style={{ display: 'flex', gap: '4rem', flexWrap: 'wrap' }}>
                    <div>
                        <h4 style={{ color: 'var(--text-main)', marginBottom: '1.5rem', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '0.1em' }}>Product</h4>
                        <ul style={{ listStyle: 'none', padding: 0, fontSize: '0.9rem' }}>
                            <li style={{ marginBottom: '0.8rem' }}><a href="#features" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }}>Features</a></li>
                            <li style={{ marginBottom: '0.8rem' }}><a href="#specs" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }}>Specifications</a></li>
                            <li style={{ marginBottom: '0.8rem' }}><a href="#pricing" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }}>Pricing</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 style={{ color: 'var(--text-main)', marginBottom: '1.5rem', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '0.1em' }}>Company</h4>
                        <ul style={{ listStyle: 'none', padding: 0, fontSize: '0.9rem' }}>
                            <li style={{ marginBottom: '0.8rem' }}><a href="#about" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }}>About</a></li>
                            <li style={{ marginBottom: '0.8rem' }}><a href="#contact" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }}>Contact</a></li>
                            <li style={{ marginBottom: '0.8rem' }}><a href="mailto:hello@seikaia.com" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }}>hello@seikaia.com</a></li>
                            <li style={{ marginBottom: '0.8rem' }}><a href="/aviso-legal.html" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }}>Aviso Legal</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                paddingTop: '2rem',
                textAlign: 'center',
                fontSize: '0.8rem',
                opacity: 0.6
            }}>
                &copy; {new Date().getFullYear()} Agroconnect S.L. All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;
